import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetSubObjectivesForStageById = createAsyncThunk(
  "GetSubObjectivesForStageById/GetSubObjectivesForStageById",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SubObjectivesForStage/GetSubObjectivesForStageById",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const DeleteSubObjectivesForStage = createAsyncThunk(
  "DeleteSubObjectivesForStage/DeleteSubObjectivesForStage",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SubObjectivesForStage/DeleteSubObjectivesForStage",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateSubObjectivesForStage = createAsyncThunk(
  "UpdateSubObjectivesForStage/UpdateSubObjectivesForStage",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SubObjectivesForStage/UpdateSubObjectivesForStage",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const SubObjectivesForStage = createSlice({
  name: "SubObjectivesForStage",
  initialState: {
    SubObjectivesForStage: {},
    loadingSubObjectivesForStage: false,
    errorSubObjectivesForStage: null,

    UpdateSubObjectivesForStage: {},
    loadingUpdateSubObjectivesForStage: false,
    errorUpdateSubObjectivesForStage: null,

    DeleteSubObjectivesForStage: {},
    loadingDeleteSubObjectivesForStage: false,
    errorDeleteSubObjectivesForStage: null,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetSubObjectivesForStageById.pending, (state, action) => {
        state.loadingSubObjectivesForStage = true;
        state.SubObjectivesForStage = action.payload;
        state.errorSubObjectivesForStage = null;
      })
      .addCase(GetSubObjectivesForStageById.fulfilled, (state, action) => {
        state.loadingSubObjectivesForStage = false;
        state.SubObjectivesForStage = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetSubObjectivesForStageById.rejected, (state, action) => {
        state.loadingSubObjectivesForStage = false;
        state.errorSubObjectivesForStage = action.payload;
      })

      .addCase(DeleteSubObjectivesForStage.pending, (state, action) => {
        state.loadingDeleteSubObjectivesForStage = true;
        state.DeleteSubObjectivesForStage = action.payload;
        state.errorDeleteSubObjectivesForStage = null;
      })
      .addCase(DeleteSubObjectivesForStage.fulfilled, (state, action) => {
        state.loadingDeleteSubObjectivesForStage = false;
        state.DeleteSubObjectivesForStage = action.payload; // Assuming payload has the desired data
      })
      .addCase(DeleteSubObjectivesForStage.rejected, (state, action) => {
        state.loadingDeleteSubObjectivesForStage = false;
        state.errorDeleteSubObjectivesForStage = action.payload;
      })

      .addCase(UpdateSubObjectivesForStage.pending, (state, action) => {
        state.loadingUpdateSubObjectivesForStage = true;
        state.UpdateSubObjectivesForStage = action.payload;
        state.errorUpdateSubObjectivesForStage = null;
      })
      .addCase(UpdateSubObjectivesForStage.fulfilled, (state, action) => {
        state.loadingUpdateSubObjectivesForStage = false;
        state.UpdateSubObjectivesForStage = action.payload; // Assuming payload has the desired data
      })
      .addCase(UpdateSubObjectivesForStage.rejected, (state, action) => {
        state.loadingUpdateSubObjectivesForStage = false;
        state.errorUpdateSubObjectivesForStage = action.payload;
      });

  },
});

export default SubObjectivesForStage.reducer;
